





















import { Vue, Component, Prop } from 'vue-property-decorator';
import { Button, Dialog, Toast, Popup } from 'vant';
import { isWeiXin } from '@/common/ts/common';
import { needSmoothCheck, vote } from '@/api/api.ts';
import SlideVerify from '@/components/SlideVerify.vue';
import qs from 'qs';
Vue.use(Popup)
  .use(Dialog)
  .use(Toast)
  .use(Button);
@Component({
  components: {
    SlideVerify,
  },
})
export default class VoteButton extends Vue {
  @Prop({ default: true }) mustApp!: boolean;
  @Prop() voteName!: string;
  @Prop() voteId!: string | number;
  @Prop() source!: string;
  @Prop() voteWeChat!: true;
  @Prop({ default: 10 }) MaxNum!: number;
  @Prop({ default: '1' }) enable!: string;
  @Prop({
    default: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.news.shangyounews',
  })
  downLoadUrl!: string;
  SlideShow = false;
  pointOut = false;
  unionId!: string | null;
  WechatLogin() {
    const { code, source } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (isWeiXin() && !code) {
      const appId = 'wx1949ed4a473b87ed';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }
  startVote() {
    // 开始投票，判断是不是必须在app内投票
    if (this.enable === '0') {
      Toast.fail('作品正在审核中');
    } else {
      // 登录
      if (
        this.voteWeChat &&
        isWeiXin() &&
        !window.localStorage.getItem('unionid')
      ) {
        this.$dialog
          .confirm({
            title: '微信登录',
            message: '点赞前需要进行微信登录',
          })
          .then(() => {
            console.log('确定');
            this.WechatLogin();
          })
          .catch(() => {
            console.log('取消');
          });
        return;
      }
      if (isWeiXin()) {
        console.log(
          '在this.$route.query.source里投票',
          window.localStorage.getItem('unionid'),
        );
        this.unionId = window.localStorage.getItem('unionid');
        const data = {
          id: this.voteId,
          source: this.source,
          unionid: this.unionId,
        };
        vote(this.voteName, data).then((result: any) =>
          this.successVote(result),
        );
      } else if (window.udid) {
        console.log('在app里投票');
        const data = {
          id: this.voteId,
          source: this.source,
          udid: window.udid,
          appkey: window.appkey,
        };
        vote(this.voteName, data).then((result: any) =>
          this.successVote(result),
        );
      }
    }
  }
  fSlideData(res: object) {
    this.SlideShow = false;
    if (this.voteWeChat && isWeiXin()) {
      const data = {
        id: this.voteId,
        source: this.source,
        unionid: this.unionId,
      };
      const lastData = Object.assign(res, data);
      vote(this.voteName, lastData).then((result: any) =>
        this.successVote(result),
      );
    } else if (window.udid) {
      const data = {
        id: this.voteId,
        source: this.source,
        udid: window.udid,
        appkey: window.appkey,
      };
      const lastData = Object.assign(res, data);
      vote(this.voteName, lastData).then((result: any) =>
        this.successVote(result),
      );
    }
  }
  successVote(res: any) {
    switch (res.code) {
      case 200:
        Toast({
          type: 'success',
          duration: 1200,
          message: res.msg,
        });
        this.$emit('votSuccess', res.data);
        break;
      case 201:
        this.SlideShow = true;
        break;
      case 202:
        if (parseFloat(window.version) >= 4.5) {
          window.handleMessage('{"action":"mUserLogin","data":""}');
        } else {
          window.location.href = 'client:logout';
        }
        break;
      case 500:
        Toast.fail(res.msg);
        break;
      case 204:
        Toast.fail(res.msg);
        break;
      case 203:
        Toast.fail(res.msg);
        break;
      case 300:
        Toast.fail(res.msg);
        break;
      case 101:
        Toast.fail(res.msg);
        break;
    }
  }
}
